<template>
    <div class="page" :style="{'--styleColor': actInfo.color, backgroundImage:'url('+ actInfo.bg_reg +')'}">
        <div class="mainBox">
          
          <van-cell-group>
            <van-form @submit="onSubmit">
              <van-field v-model="personName" name="personName" label="" placeholder="请输入姓名" :rules="[{ required: true, message: '' }]">
                <van-icon class="iconfont" class-prefix="icon" slot="left-icon" name="zhengjian" size="20"></van-icon>
              </van-field>

              <van-field v-model="idCard" name="idCard" type="tel" label="" placeholder="请输入身份证号" :rules="[{ required: true, message: '' }]">
                <van-icon class="iconfont" class-prefix="icon" slot="left-icon" name="zhengjian" size="20"></van-icon>
              </van-field>

              <van-field v-if="actInfo.area_linkageid>0" v-model="areaName" name="areaName" is-link readonly placeholder="请选择所属单位" @click="showSelect = true" :rules="[{ required: true, message: '' }]">
                <van-icon class="iconfont" class-prefix="icon" slot="left-icon" name="gongsiqiye1" size="20"></van-icon>
              </van-field>

              <van-popup v-model="showSelect" closeable position="bottom" :style="{ height: '90%' }" class="areaBox">
                <van-index-bar highlight-color="#1989fa" :index-list="indexList">
                  <div v-for="item in filterData" :key="item.letter">
                    <van-index-anchor :index="item.letter"></van-index-anchor>
                    <van-cell v-for="(row,index) in item.list" :key="index" :title="row.text" @click="setAreaid(row)"/>
                  </div>
                </van-index-bar>
              </van-popup>

              <van-field v-model="areaId" name="areaId" type="hidden"  style="display:none;">
              </van-field>

              <!-- <van-field v-model="address" name="address" label="" placeholder="请输入详细地址" :rules="[{ required: true, message: '' }]">
                <van-icon class="iconfont" class-prefix="icon" slot="left-icon" name="dingwei1" size="20"></van-icon>
              </van-field> -->

              <!-- <van-field v-model="company" name="company" label="" placeholder="请输入企业名称" :rules="[{ required: true, message: '' }]">
                <van-icon class="iconfont" class-prefix="icon" slot="left-icon" name="zixun" size="20"></van-icon>
              </van-field> -->
              <van-field v-if="actInfo.permiss==3" v-model="account" name="account" type="tel" label="" placeholder="请输入账号" :rules="[{ required: true, message: '' }]">
                <van-icon class="iconfont" class-prefix="icon" slot="left-icon" name="renwu-ren" size="20"></van-icon>
              </van-field>
              <van-field v-if="actInfo.permiss==1||actInfo.permiss==2||actInfo.permiss==3" v-model="passCode" name="passCode" placeholder="请输入密码口令" :rules="[{ required: true, message: '' }]">
                <van-icon class="iconfont" class-prefix="icon" slot="left-icon" name="suo" size="20"></van-icon>
              </van-field>

              <div class="subBtn">
                <van-button round block type="info" native-type="submit">提交信息</van-button>
              </div>

            </van-form>
          </van-cell-group>
        
        </div>

        

        <!-- <div class="navBox">
          <div class="navTxt" @click="toHome"><i class="iconfont icon-zhuye"></i>首页</div>
          <div class="navTxt" @click="toMyCenter"><i class="iconfont icon-wode1"></i>个人中心</div>
        </div> -->
    </div>


    
</template>

<script>

import {reqAdd} from '@/api/index.js' //动态接口
import {reqArea} from '@/api/index2.js' //静态接口
import Cookies from 'js-cookie'
import zonglan from '@/utils/cp-zonglan.js'
//分享
import { wxShare } from '@/utils/wxshare-wes2.com.js'

export default {
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      learnid:0,
      token:"",
      actInfo:"",
      title:"",
      shareTitle:"",
      shareDesc:"",      
      showNotice:false,
      showKefu:false,
      personName:'',
      idCard:'',
      address:'',
      company:'',
      passCode:'',
      showSelect: false,
      areaName: '',
      areaId: '',
      // 选项列表，children 代表子选项，支持多级嵌套
      options: [
        {
          text: '省政府有关部门',
          value: '1',
          children: [
            { 
              text: '河北省发展和改革委员会', 
              value: '3',
              children:[
                { text:'石家庄',value:'8'}
              ]
            },
            { text: '河北省人力资源和社会保障厅', value: '4' },
            { text: '河北省水利厅', value: '5' }
          ],
        },
        {
          text: '江苏省',
          value: '2',
          children: [{ text: '南京市', value: '6' }],
        },
      ],

      indexList: [],
      filterData:[], // 处理后的 待渲染数据      
      areaList:[],
      shareImg:"https://img2.hebnews.cn/img/home.53fe0d7.png",
      shareTitle:"",
      shareDesc:"", 
      style:{},
    }
  },
  computed: {},
  watch: {},
  created () {
    this.learnid = this.$route.query.learnid;
    this.token = this.$store.state.token;
    this.accountId = this.$store.state.accountId;
    this.uniqueId = this.$store.state.uniqueId;
    this.actInfo = this.$store.state.actInfo;
    this.shareImg = this.$store.state.actInfo.share_img;
    this.shareTitle = this.$store.state.actInfo.share_title;
    this.shareDesc = this.$store.state.actInfo.share_desc;
    this.actInfo = this.$store.state.actInfo;
  },
  mounted() {
    if(this.actInfo.area_linkageid>0) {
      this.getArea()
    }    
    // zonglan.pageShare(0,'',this.shareImg,this.shareTitle,this.shareDesc);    
  },
  methods: {   
    setAreaid(row){
      console.log('row',row);
      this.areaId = row.value;
      this.areaName = row.text;
      this.showSelect = false;
    },
    areaData(){      
      // 安装使用 js-pinyin 插件，获取待处理字段的拼音
      const pinyin = require('js-pinyin');
      
      this.areaList.map(item => { item.pinyin = pinyin.getFullChars(item.text); });
      // console.log('this.areaList',this.areaList);
      let provice = {};          
      this.areaList.map((item) => {         
        const Initials = item.pinyin[0].toUpperCase();      
        // 如果对象里有当前字母项则直接 push 一个对象,如果没有则创建一个新的键并赋值;     
        if (provice[Initials]) {     
          provice[Initials].push(item);       
        } else {     
          provice[Initials] = [item];      
        }       
      });

      // 将数据转为数组，并按字母顺利排列
      this.filterData = [];  
      for(let key in provice) {
        const obj = { letter: key, list:provice[key] };
        // console.log('obj',obj);
        this.filterData.push(obj)
      }    
      this.filterData.sort((a,b) => { return a.letter.localeCompare(b.letter) });
      // 为索引字符数组赋值
      this.indexList = [];
      this.filterData.forEach(item => this.indexList.push(item.letter));
      // console.log('filterData',this.filterData)
    }, 
    // 全部选项选择完毕后，会触发 finish 事件
    // onFinish({ selectedOptions }) {
    //   this.showSelect = false;
    //   this.areaName = selectedOptions.map((option) => option.text).join('/');
    //   if(selectedOptions.length>0){
    //     this.areaId = selectedOptions[selectedOptions.length-1].value;
    //   }else{
    //     this.areaId = selectedOptions[0].value;
    //   }      
    // },
    async getArea() {      
      let result = await reqArea({linkageid:this.actInfo.area_linkageid});
      this.areaList = result;
      this.areaData()
    },
    async onSubmit(values) { //表单提交
      console.log('submit', values);
      let result = await reqAdd({...values,learnid:this.learnid,hbrb_account_id:this.accountId,hbrb_unique_id:this.uniqueId});
      if(result.flag == 'success'){
        localStorage.clear(); //清空本地观看记录
        Cookies.set('ckplayer-player-cookie','');
        this.$router.push({ path: '/list',query:this.$route.query })  //直接进入课程列表页
      } else {
        this.$toast({
          icon: 'warning-o',
          message: result.message
        });
      }

    },
    noticeBox(){ //显示活动须知弹窗
      this.showNotice = true;
    },
    kefuBox(){ //显示客服弹窗
      this.showKefu = true;
    },
    toHome(){
      this.$router.push({ path: '/list',query:this.$route.query })
    },
    toMyCenter(){
      this.$router.push({ path: '/mycenter',query:this.$route.query })
    }
  },
}
</script>
<style lang="scss" scoped>
.page{
  width: 750px;
  min-height: 1366px;
  font-size: 30px;
  background-repeat: no-repeat;
  background-size: contain;
  .mainBox{
    width: 600px;
    min-height:480px;    
    position: absolute;
    left: 25px;
    top: 380px;    
    background: #fff;
    border-radius: 20px;
    padding:80px 50px;
    padding-top: 80px;

    .subBtn{ margin:0px; margin-top:50px;}
    .van-button{ background: var(--styleColor); border: 0px; border-radius: 15px;}
    .iconfont{ padding-right: 15px; margin-right:20px; border-right: 2px solid #e7e8e8;}
    .van-cell{ border:2px solid #e7e8e8; padding:12px 15px; margin-bottom: 30px; border-radius: 10px;}
    .van-cell::after{ border:0px;}

    .areaBox{
      .van-cell{ border:0px; margin:0px 15px; margin-bottom: 10px; border-radius: 0px;}
      .van-index-anchor{ font-weight: bold;}
    }
    ::v-deep .van-index-bar__index{
      padding: 10px 20px;
      font-size: 26px;
    }

  }

  .noticBox{ width: 100%; height: auto; font-size: 30px; padding-bottom: 80px; overflow: hidden;}
  .noticTitle{ display: block; width: 100%; height: 30px; margin-top: 80px; font-size: 34px; display: flex; align-items: center; justify-content: center;}
  .noticTxt{ width: 670; height: auto;  padding:0px 40px; margin-bottom: 30px; overflow: hidden; overflow-y: auto;}
  .noticTxt p{ padding: 0; margin: 15px 0px; width: 100%; text-indent: 2em; text-align: justify;}
  .noticBox .text{ padding: 0px 30px; color:var(--styleColor);}
  .noticBox .line{ border-top: 1px solid var(--styleColor); width: 130px; }
  




  .navBox{
    position: fixed;
    left: 0px;
    bottom: 0px;
    width: 750px;
    height: 100px;
    background: #f9f9f9;
    border-top: 1px solid #c8c8c8;
    display: flex;
    justify-content: space-evenly;
    font-size: 30px;
    .navTxt{
      padding:0px 50px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #808080;
      font-weight: 400;
      i{
        font-size: 40px;
        margin-right: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        // color:#808080
      }
    }
  }

}
</style>
